import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE from "../api/api";
import "./buy.css";

const BuyNowPage = () => {
  const navigate = useNavigate();
const userData = JSON.parse(localStorage.getItem("user") || "{}");

const userEmail = userData.email || "";
const userPhone = userData.phone || "";
const userName = userData.name || "";

const [formData, setFormData] = useState({
  name: userName,
  phone: userPhone.replace("+91", ""),
  pincode: "",
  locality: "",
  address: "",
  city: "",
  state: "",
  landmark: "",
  alternatePhone: "",
  addressType: "Home",
  email: userEmail || "",
});

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [localities, setLocalities] = useState([]);

  // ✅ Check if user already has address saved
useEffect(() => {
  if (!userEmail) return;

  fetch(`${API_BASE}/getaddress.php`, {
    method: "GET",
    credentials: "include",
  })
    .then((res) => res.json())
    .then((data) => {
      console.log("ADDRESS DATA:", data);

      if (data.status === "success" && data.data.length > 0) {
        navigate("/checkout", {
          state: {
            addressId: data.data[0].id,
            cartItems: JSON.parse(localStorage.getItem("cartItems")) || [],
            totalAmount: (
              JSON.parse(localStorage.getItem("cartItems")) || []
            ).reduce((sum, item) => sum + item.price * item.qty, 0),
          },
        });
      }
    })
    .catch((err) => console.error("Error checking address:", err));
}, [userEmail, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "name") {
      const cleanValue = value.replace(/[^A-Za-z\s]/g, "");
      setFormData((prev) => ({ ...prev, [name]: cleanValue }));
      return;
    }

    if (name === "pincode") {
      if (/^\d*$/.test(value) && value.length <= 6) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
      return;
    }

    if (name === "phone" || name === "alternatePhone") {
      if (/^\d*$/.test(value) && value.length <= 10) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

useEffect(() => {
  const fetchPincodeDetails = async () => {

    if (formData.pincode.length !== 6) {

      setLocalities([]);

      setFormData((prev) => ({
        ...prev,
        city: "",
        state: "",
        locality: "",
      }));

      return;
    }

    try {

      console.log("FETCHING PINCODE:", formData.pincode);

const res = await fetch(
  `${API_BASE}/getPincode.php?pincode=${formData.pincode}`
);

      const data = await res.json();

      console.log("PINCODE RESPONSE:", data);

      if (
        !Array.isArray(data) ||
        data[0]?.Status !== "Success" ||
        !data[0]?.PostOffice
      ) {
        throw new Error("Invalid response");
      }

      const offices = data[0].PostOffice;

      console.log("POST OFFICES:", offices);

      const uniqueLocalities = [
        ...new Set(
          offices
            .map((o) => o.Name?.trim())
            .filter(Boolean)
        ),
      ];

      console.log("LOCALITIES:", uniqueLocalities);

      setLocalities(uniqueLocalities);

      setFormData((prev) => ({
        ...prev,
        city: offices[0]?.District || "",
        state: offices[0]?.State || "",
        locality: uniqueLocalities[0] || "",
      }));

    } catch (err) {

      console.error("PINCODE ERROR:", err);

      setLocalities([]);

      setFormData((prev) => ({
        ...prev,
        city: "",
        state: "",
        locality: "",
      }));
    }
  };

  fetchPincodeDetails();

}, [formData.pincode]);

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required.";
    else if (!/^[A-Za-z\s]+$/.test(formData.name.trim()))
      newErrors.name = "Name must contain only letters.";
    if (!/^[6-9]\d{9}$/.test(formData.phone))
      newErrors.phone = "Enter a valid 10-digit Indian phone number.";
    if (!/^\d{6}$/.test(formData.pincode))
      newErrors.pincode = "Pincode must be exactly 6 digits.";
    if (!formData.address.trim()) newErrors.address = "Address is required.";
    if (!formData.city) newErrors.city = "City is required.";
    if (!formData.state) newErrors.state = "State is required.";
    if (formData.alternatePhone && !/^[6-9]\d{9}$/.test(formData.alternatePhone))
      newErrors.alternatePhone = "Enter a valid 10-digit alternate number.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validate()) return;

  setSubmitting(true);

  try {
    const response = await fetch(`${API_BASE}/saveAddress.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    console.log("SAVE ADDRESS:", data);

    if (data.status === "success") {
      navigate("/checkout", {
        state: {
          addressId: null, // backend अभी id नहीं भेज रहा
          cartItems: JSON.parse(localStorage.getItem("cartItems")) || [],
          totalAmount: (
            JSON.parse(localStorage.getItem("cartItems")) || []
          ).reduce((sum, item) => sum + item.price * item.qty, 0),
        },
      });
    } else {
      alert(data.message || "Something went wrong");
    }

  } catch (err) {
    console.error("Network error:", err);
    alert("Network error, try again");
  } finally {
    setSubmitting(false);
  }
};

  return (
    <div className="buy-now-wrapper">
      <div className="buy-now-container">
        <button
  className="back-btn"
  onClick={() => navigate(-1)}
>
  ← Back
</button>
        <h2 className="title">Delivery Address</h2>
        <form className="address-form" onSubmit={handleSubmit}>
          <div className="row">
            <input
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
            />
            <span className="error">{errors.name}</span>
            <div className="phone-input">
              <span className="prefix">+91</span>
              <input
                name="phone"
                placeholder="Mobile Number"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            <span className="error">{errors.phone}</span>
          </div>

          <div className="row">
            <input
              name="pincode"
              placeholder="Pincode"
              value={formData.pincode}
              onChange={handleChange}
            />
            <span className="error">{errors.pincode}</span>

{localities.length > 0 ? (
  <select
    name="locality"
    value={formData.locality}
    onChange={handleChange}
  >
    {localities.map((loc, idx) => (
      <option key={idx} value={loc}>
        {loc}
      </option>
    ))}
  </select>
) : (
  <input
    name="locality"
    placeholder="Locality"
    value={formData.locality}
    readOnly
  />
)}
          </div>

          <textarea
            name="address"
            placeholder="Address (Area and Street)"
            value={formData.address}
            onChange={handleChange}
          />
          <span className="error">{errors.address}</span>

          <div className="row">
            <input
              name="city"
              placeholder="City/District/Town"
              value={formData.city}
              readOnly
            />
            <span className="error">{errors.city}</span>
            <input
              name="state"
              placeholder="State"
              value={formData.state}
              readOnly
            />
            <span className="error">{errors.state}</span>
          </div>

          <div className="row">
            <input
              name="landmark"
              placeholder="Landmark (Optional)"
              value={formData.landmark}
              onChange={handleChange}
            />
            <div className="phone-input">
              <span className="prefix">+91</span>
              <input
                name="alternatePhone"
                placeholder="Alternate Phone (Optional)"
                value={formData.alternatePhone}
                onChange={handleChange}
              />
            </div>
            <span className="error">{errors.alternatePhone}</span>
          </div>

          <div className="actions">
            <button type="submit" className="save-btn" disabled={submitting}>
              {submitting ? "Saving..." : "Save and Deliver Here"}
            </button>
            <button
              type="button"
              className="cancel-btn"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BuyNowPage;
